// src/pages/CreateForm.js
import React from 'react';
import FormBuilder from '../components/FormBuilder/FormBuilder';

const CreateForm = () => {
  return (
    <div>
      <FormBuilder />
    </div>
  );
};

export default CreateForm;
